import type { CaptionPresetId, CaptionSettings } from '@/types';

type PresetPatch = Omit<Partial<CaptionSettings>, 'overridesShared' | 'enabled' | 'preset'>;

export const CAPTION_PRESETS: Record<CaptionPresetId, { label: string; patch: PresetPatch }> = {
  clean: {
    label: 'Clean',
    patch: {
      fontFamily: 'Inter',
      fontWeight: 700,
      textColor: '#ffffff',
      outlineColor: '#000000',
      outlineWidthPx: 5,
      backgroundOpacity: 0,
      animation: 'fade-in',
    },
  },
  'bold-social': {
    label: 'Bold Social',
    patch: {
      fontFamily: 'Montserrat',
      fontWeight: 800,
      fontSizePx: 74,
      textColor: '#ffffff',
      outlineColor: '#000000',
      outlineWidthPx: 8,
      backgroundOpacity: 0,
      animation: 'pop',
      letterSpacingPx: 0.5,
    },
  },
  minimal: {
    label: 'Minimal',
    patch: {
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSizePx: 52,
      textColor: '#ffffff',
      outlineColor: '#000000',
      outlineWidthPx: 0,
      backgroundColor: '#000000',
      backgroundOpacity: 0.35,
      animation: 'fade-in',
    },
  },
  boxed: {
    label: 'Boxed',
    patch: {
      fontFamily: 'Poppins',
      fontWeight: 700,
      textColor: '#ffffff',
      outlineWidthPx: 0,
      backgroundColor: '#111827',
      backgroundOpacity: 0.85,
      animation: 'slide-up',
    },
  },
  'high-contrast': {
    label: 'High Contrast',
    patch: {
      fontFamily: 'Bebas Neue',
      fontWeight: 700,
      fontSizePx: 80,
      textColor: '#fef08a',
      outlineColor: '#000000',
      outlineWidthPx: 10,
      backgroundOpacity: 0,
      animation: 'pop',
    },
  },
  karaoke: {
    label: 'Karaoke-style',
    patch: {
      fontFamily: 'Montserrat',
      fontWeight: 800,
      textColor: '#ffffff',
      outlineColor: '#000000',
      outlineWidthPx: 6,
      backgroundOpacity: 0,
      animation: 'word-highlight',
      activeWordColor: '#4a5cf7',
    },
  },
  'cinematic-script': {
    label: 'Cinematic Script',
    patch: {
      fontFamily: 'Alex Brush',
      fontWeight: 400,
      fontSizePx: 68,
      textColor: '#ffffff',
      outlineColor: '#000000',
      outlineWidthPx: 0,
      backgroundOpacity: 0,
      alignment: 'center',
      lineHeight: 1.3,
      animation: 'fade-in',
    },
  },
};
